<template>
  <div class="title-wrap">
    <div class="title h1" v-html="title"/>
    <div class="title-shadow" v-html="titleShadow"/>
  </div>
</template>

<script>
export default {
  name: "ShadowTitle",
  props: {
    title: {
      type: String,
      default: 'Заголовок'
    },
    titleShadow: {
      type: String,
      default: 'Заголовок'
    }
  }
}
</script>

<style lang="scss" scoped>
.title-wrap {
  position: relative;
  margin-bottom: 32px;

  @include _768 {
    margin-bottom: 80px;
  }

  .title {
    position: relative;
    z-index: 5;
  }

  .title-shadow {
    font-family: 'Museo Sans Cyrl',sans-serif;
    font-size: 70px;
    font-weight: 700;
    line-height: normal;
    white-space: nowrap;
    text-align: right;
    color: rgba(255, 255, 255, 0.1);
    position: absolute;
    bottom: -50%;
    right: -14px;
    width: 100%;
    @include _768 {
      font-size: 100px;
      bottom: 0;
    }
    @include _992 {
      font-size: 158px;
      right: 0;
      bottom: -44px;
    }
  }
}
</style>